/**
 * Where the server is.
 *
 * On the web this is empty and every request stays same-origin relative, which
 * is what lets one build run on tira.pamore.app, a preview, or localhost
 * without knowing which. Inside the native app shell the WebView's origin is
 * `capacitor://localhost` — an address nothing listens on — so the mobile
 * build bakes the real server in via VITE_SERVER_ORIGIN.
 *
 * Build-time rather than a runtime probe of `location.protocol`: the app shell
 * is the one deployment whose server cannot be inferred from where the code is
 * running, and a probe would be a guess in exactly the case that matters.
 */
export const SERVER_ORIGIN: string = (import.meta.env.VITE_SERVER_ORIGIN as string | undefined) ?? '';

/** `wss://…` for the baked origin, `wss://<host>` / `ws://<host>` same-origin. */
export function wsUrl(): string {
  if (SERVER_ORIGIN !== '') return `${SERVER_ORIGIN.replace(/^http/, 'ws')}/ws`;
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${location.host}/ws`;
}
